import axios from "axios"
import { baseUrl, TOKEN_KEY } from "./constants"

export const api = axios.create({
    baseURL: baseUrl
})

api.interceptors.request.use(config => {
    let token = localStorage.getItem(TOKEN_KEY)
    if(token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

api.interceptors.response.use(
    response => response,
    error => {
        if(error.response && error.response.status == 403){
            localStorage.removeItem(TOKEN_KEY)
            window.location.href = '/'
        }
        return Promise.reject(error)
    }
)